// extracted by mini-css-extract-plugin
export var active = "_23-b";
export var activeIndicator = "_23-6";
export var animate = "_23-a";
export var disabled = "_23-c";
export var flat = "_23-1";
export var fullWidth = "_23-3";
export var lg = "_23-9";
export var md = "_23-8";
export var redoButtonTabGroup = "_23-0";
export var sm = "_23-7";
export var tabButton = "_23-4";
export var tabButtonsContainer = "_23-2";
export var xs = "_23-5";